import {
    Dialog,
    DialogActions,
    DialogContent,
    Typography,
    IconButton,
    Box,
    Grid
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Button, H3 } from "../reusable-components";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { track } from "../analytics/analytics";

interface ShareDialogProps {
    open: boolean;
    publicUrl: string;
    onClose: () => void;
}

const ShareDialog: React.FC<ShareDialogProps> = (props) => {

    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        track("coupon_shared", { method: "copy_link" });
        try {
            // Ensure the iframe/window is focused
            window.focus();

            // Try modern Clipboard API
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(props.publicUrl);
                setCopied(true);
            } else {
                copyToClipboardFallback(props.publicUrl);
                setCopied(true);
            }
        } catch (e) {
            console.error("Clipboard copy failed:", e);
            // Try fallback if clipboard API fails
            copyToClipboardFallback(props.publicUrl);
            setCopied(true);
        }
    };

    const copyToClipboardFallback = (text: string) => {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            document.execCommand("copy");
        } catch (e) {
            console.error("Fallback copy failed:", e);
        }
        document.body.removeChild(textArea);
    };

    return (
        <Dialog open={props.open} onClose={props.onClose} disableRestoreFocus
            disableEnforceFocus
            sx={{ '& .MuiDialog-container': { alignItems: 'flex-start', paddingTop: '20vh' } }}
            PaperProps={{ sx: { borderRadius: "var(--radius)", backgroundColor: "var(--background_2)" } }}>
            <DialogContent sx={{ paddingLeft: "50px", paddingRight: "50px" }}>
                <Grid container alignContent="center" direction="column">

                    <H3>{t('share_coupon')}</H3>
                </Grid>
                <Grid container alignContent="center" direction="column">

                    {/* Copy link or copied message */}
                    <Box display="flex" alignItems="center" gap={1} mt={1}>
                        <Typography sx={{ color: "var(--text-black)" }} textAlign="center" fontSize="small" marginTop="5px" marginBottom="5px">
                            {copied ? t('copied') : t('copy_link')}
                        </Typography>

                        {!copied && (
                            <IconButton sx={{ color: "var(--text-black)" }} onClick={handleCopy} size="small">
                                <ContentCopyIcon fontSize="small" />
                            </IconButton>
                        )}
                    </Box>
                </Grid>

            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", paddingBottom: "20px" }}>
                <Button onClick={props.onClose}>
                    {t('ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ShareDialog;
